import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "max-w-full w-fit flex flex-col gap-6 items-center bg-main-100/70 rounded-lg px-8 py-4 text-main-5 shrink-0 shadow-material"
};
const _hoisted_2 = {
  class: "flex flex-col gap-3 items-center"
};
const _hoisted_3 = {
  class: "text-center text-base font-bold"
};
const _hoisted_4 = {
  class: "relative h-1 max-w-full w-[160px] rounded-lg bg-second-100/40"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  return this.userSubscription.active ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("i", {
    class: "icon-diamond text-[48px]"
  }, null, -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(this.$st('payments.modals.status-card.your-plan', {
    name: this.userSubscription.name
  })), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["absolute left-0 h-full w-0 bg-cta-100 rounded-lg transition-[width] duration-500 after:block after:absolute after:right-0 after:h-full", [{
      'bg-pro_dark after:aspect-square after:shadow-[0_0_14px_3px_var(--color-cta-100)]': this.userSubscription.slansPercentage > 5
    }, {
      'bg-error!': this.userSubscription.slansPercentage >= 100
    }]]),
    style: _normalizeStyle(`max-width: 100%; width: ${this.userSubscription.slansPercentage}%`)
  }, null, 6)]), _createElementVNode("p", null, _toDisplayString(_ctx.$st('payments.used-slans', {
    value: `${this.userSubscription.usedSlans}/${this.userSubscription.usageLimit}`
  })), 1)]), _createVNode(_component_Button, {
    size: "sm",
    variant: "pro",
    text: this.$st('payments.improve-plan'),
    onClick: _cache[0] || (_cache[0] = $event => this.$router.push({
      name: 'Payments'
    }))
  }, null, 8, ["text"])])) : _createCommentVNode("", true);
}